import Entity from './entity'
export default class Thequipment extends Entity<number>{
    Id:number;
    mac:string;
    status:Number=1;
    etype:Number;
    ftId:Number;
    wId:Number;
    fId:Number;
    updateInterval:Object;
    AcquisitionInterval:number;
    updateG:Object;
    scId:Number;
    //temp:Number;
    //humi:Number;
}